import React, {PropsWithChildren, ReactElement} from "react";
import classNames from "classnames";

interface Props {
	className?: string;
}

function FrameModalBody(props: PropsWithChildren<Props>): ReactElement {

	return (
		<div className={classNames("frame-one-modal_body", props.className)}>
			{props.children}
		</div>
	);
}

export default FrameModalBody;
